import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function AboutSection() {
  return (
    <section className="relative py-24 lg:py-32 bg-[#0a0a0a]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <span className="divider-line" />
            <span className="text-[11px] tracking-[0.4em] text-[#B87333]">ÇÖZÜM ORTAKLIĞI</span>
          </div>
          <h2 className="font-serif-display text-[#f5ede1] text-4xl md:text-5xl lg:text-6xl leading-[1.05] font-light">
            İşletmeniz için attığınız her adımda <span className="italic text-[#B87333]">daima</span> yanınızdayız.
          </h2>
          <Link
            to="/hakkimizda"
            className="inline-flex items-center gap-3 mt-10 px-8 py-4 bg-transparent border border-[#B87333] text-[#B87333] text-[11px] tracking-[0.3em] font-semibold hover:bg-[#B87333] hover:text-[#0a0a0a] transition-colors duration-300"
          >
            DAHA FAZLA <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="lg:col-span-7 space-y-6 text-[#a89a85] leading-relaxed">
          <p>
            Bugün, şirketimizin yatırım teşvikleri alanındaki uzmanlığına odaklanarak büyüme yolculuğumuzda yeni bir döneme adım atmanın heyecanını yaşıyoruz. Kurulduğumuz günden bu yana, misyonumuz işletmelerin potansiyellerini en üst düzeye çıkarmak ve onlara gelecekteki başarılarına yönelik sağlam bir temel oluşturmaktı.
          </p>
          <p>
            Bu misyon doğrultusunda, yatırım teşvikleri konusunda sunduğumuz çözümlerle birçok işletmenin büyümesine katkıda bulunarak kendimizi kanıtladık. Şimdi, bu başarı hikayesini daha da ileri taşıma zamanı geldiğine inanıyoruz.
          </p>
          <p>
            Yeni yatırımların, büyüme fırsatlarının ve stratejik ortaklıkların önümüzdeki dönemde bizi beklediğini biliyoruz. Yatırım teşvikleri konusundaki uzmanlığımızı daha da derinleştirerek, işletmelerin ihtiyaçlarına daha etkin ve verimli çözümler sunmayı hedefliyoruz.
          </p>
          <div className="pt-8 border-t border-[#B87333]/20">
            <h3 className="font-serif-display text-[#f5ede1] text-3xl lg:text-4xl">
              Teşvik Edici Çözümler…
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
}
